import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { format } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateTime(dateStr: string | undefined | null) {
  if (!dateStr) return "-";
  try {
  // Replace first space with T for proper ISO 8601 parsing across browsers
  const normalizedDate = dateStr.replace(' ', 'T');
  // Ensure UTC parsing if no timezone is specified
  const dateToParse = normalizedDate.endsWith('Z') || normalizedDate.includes('+')
        ? normalizedDate
        : `${normalizedDate}Z`;
  const date = new Date(dateToParse);
  if (isNaN(date.getTime())) return "-";
  // Date object automatically converts UTC to user's local timezone
  return format(date, "hh:mm a dd/MM/yyyy");
  } catch (e) {
  return "-";
  }
}
